import classNames from 'classnames';
import * as React from 'react';

export interface FieldHelpProps extends React.PropsWithChildren {
    className?: string;
}

export const FieldHelp: React.FunctionComponent<FieldHelpProps> = ({className, children}: FieldHelpProps) => (
    <p className={classNames('mp-field-help', className)}>
        {children}
    </p>
);
